import { render, staticRenderFns } from "./FclList.vue?vue&type=template&id=490e623a&scoped=true"
import script from "./FclList.vue?vue&type=script&lang=js"
export * from "./FclList.vue?vue&type=script&lang=js"
import style0 from "./FclList.vue?vue&type=style&index=0&id=490e623a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e623a",
  null
  
)

export default component.exports